import { useState, useContext } from "react";
import { gql, useQuery } from "@apollo/client";

import { Field } from "formik";

import { MultiSelect } from "primereact/multiselect";
import { FormContext } from "../../../context/formContext";
import { UserContext } from "../../../context/userContext";

import styles from "../../../styles/Form.module.css";

export default function LocationIds({ field, block, index, organization_id }) {
  const [programList, setProgramList] = useState([]);

  const form = useContext(FormContext);
  const userCtx = useContext(UserContext);
  const isDisabled = form ? form.blocksSaved[block] : false;

  organization_id = userCtx.checkOrgPropWithFallback("organization_id", organization_id, "LocationIds")

  const GET_LOCATIONS = gql`
    query getLocations($staff_id: ID!, $organization_id: ID!) {
      locations(staff_id: $staff_id, organization_id: $organization_id) {
        key: location_id
        label: location_name
      }
    }
  `;
  useQuery(GET_LOCATIONS, {
    fetchPolicy: "network-only",
    variables: {
      staff_id: "0",
      organization_id: organization_id,
    },
    onCompleted: ({ locations }) => {
      setProgramList(locations);
    },
    skip: !userCtx,
  });

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        // display: fieldVisibility(field.field_visibility),
      }}
    >
      <label className={styles.label}>{field.field_label}</label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <Field name={field.field_name}>
        {({ field: formikField, meta }) => (
          <>
            <MultiSelect
              placeholder="Please select"
              id={field.field_name}
              name={formikField.name}
              value={formikField.value}
              onChange={formikField.onChange}
              disabled={isDisabled}
              options={programList}
            />
            {meta.touched && meta.error && (
              <div className={styles.errFieldMsg}>{meta.error}</div>
            )}
          </>
        )}
      </Field>
    </div>
  );
}
